<template>
  <v-touch @tap="tap">
    <a
      class="t-page-link"
      :href="href"
      :rel="linkRel"
      :target="target"
      :title="linkTitle"
      :style="style"
      @click="click"
      draggable="false"
      @dragstart="dragstart"
      ><span v-if="anchorText">{{ anchorText }}</span></a
    >
  </v-touch>
</template>

<style scoped>
.t-page-link,
.t-page-link:link,
.t-page-link:visited,
.t-page-link:hover,
.t-page-link:active {
  position: absolute;
  display: block;
  text-decoration: none;
}

.t-page-link > span {
  color: transparent;
}
</style>

<script>
export default {
  name: 'PageLink',

  inheritAttrs: false,

  props: {
    anchorText: {type: String},
    destination: {type: String},
    destinationType: {
      type: String,
      required: true,
      validator: v =>
        [
          'anchor_ref',
          'attachment_ref',
          'logical_page',
          'old_style',
          'page_ref',
          'print_page',
          'script',
          'url_ref',
        ].includes(v),
    },
    height: {type: Number, required: true},
    htmlClass: {type: String},
    left: {type: Number, required: true},
    linkRel: {type: String},
    linkTitle: {type: String},
    pageNum: {type: Number},
    target: {type: String},
    top: {type: Number, required: true},
    width: {type: Number, required: true},
  },

  inject: ['pubInfo'],

  computed: {
    href() {
      switch (this.destinationType) {
        case 'page_ref':
          return `/${this.pubInfo.urlId}/${this.pageNum}`
        default:
          return this.destination || '#'
      }
    },

    style() {
      return {
        top: `${this.top}%`,
        left: `${this.left}%`,
        height: `${this.height}%`,
        width: `${this.width}%`,
      }
    },
  },

  methods: {
    tap(event) {
      // Mark the source event to avoid Zoomable additionally
      // handling it as a single or double tap.
      event.srcEvent.iGotThis = true

      switch (this.destinationType) {
        case 'anchor_ref':
        case 'attachment_ref':
        case 'logical_page':
        case 'old_style':
        case 'url_ref':
          document.location = this.destination
          break

        case 'page_ref':
          event.srcEvent.preventDefault()
          this.$pub('go', this.pageNum)
          break

        case 'print_page':
          event.preventDefault()
          console.warn('No printing in Reader App yet')
          break

        case 'script':
          event.preventDefault()
          console.warn('No custom scripts in Reader App')
          break

        default:
          console.error(`Unknown destinationType="${this.destinationType}"`)
          if (!this.destination) {
            event.preventDefault()
          }
          break
      }
    },

    click(event) {
      // Everything is done in tap handler, including clicks on
      // desktop.
      event.preventDefault()
    },

    /**
     * Prevent dragging on Firefox, which doesn't always respect
     * draggable="false". Preventing dragging is important so the page
     * remains pannable with the mouse on desktop, rather than uselessly
     * starting a drag-n-drop operation on a link.
     *
     * https://stackoverflow.com/questions/26356877/html5-draggable-false-not-working-in-firefox-browser
     */
    dragstart(event) {
      event.preventDefault()
    },
  },
}
</script>
